import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: null,
};
//öğrenci Idsini tutuyor
export const studentDetailSlice = createSlice({
  name: "studentDetail",
  initialState,
  reducers: {
    handleStudentId: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { handleStudentId } = studentDetailSlice.actions;
export default studentDetailSlice.reducer;
